module.exports = __webpack_public_path__ + "img/en.68b4d830.svg";